import EfScrollAni from '@/efscrollani';
import { useProductStore } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import StatusA from './StatusA';
import './index.scss';

export default function ExampleProductA() {
    const { pageStatus } = useProductStore();

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    return <div className="page-product">{pageStatus === IPageStatus.statusA && <StatusA />}</div>;
}
